'use strict';

define(['./config/RouteConfig', './tiles/vehicle/app', './tiles/address/app', './tiles/additional/app', './tiles/quote/app', 'edge/quoteandbind/quickquote/common/app', 'edge/platform/viewmodel/module', 'edge/platform/flow/module'], function (RouteConfig) {

    return angular.module('edge.quoteandbind.quickquote.pa.app', ['edge.quoteandbind.quickquote.common.app', 'edge.quoteandbind.quickquote.pa.tiles.vehicle', 'edge.quoteandbind.quickquote.pa.tiles.address', 'edge.quoteandbind.quickquote.pa.tiles.additional', 'edge.quoteandbind.quickquote.pa.tiles.quote']).config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
        var states = new RouteConfig(RootStateConfig);
        for (var stateName in states) {
            if (states.hasOwnProperty(stateName)) {
                $stateProvider.state(stateName, states[stateName]);
            }
        }
    }]);
});


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/conditional?if=quoteandbind_lob&equals=pa!./common/js/src/edge/quoteandbind/quickquote/pa/app.js
 ** module id = 783
 ** module chunks = 0
 **/